import React, { useState } from 'react';
import { Title, Text, Paper, TextInput, Table, Button, Avatar, Badge, Group, Select, SimpleGrid } from '@mantine/core';
import { Users, Search, Plus, Filter, ArrowLeft, Download, Upload, TrendingUp, MessageCircle } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { ContactDetailsModal } from '../components/ContactDetailsModal';
export function ListDetailsPage() {
  const navigate = useNavigate();
  const {
    listId
  } = useParams();
  const [selectedContact, setSelectedContact] = useState<any>(null);
  const [modalOpened, setModalOpened] = useState(false);
  const listName = 'Deputados';
  const listDescription = 'Lista de deputados estaduais';
  const contacts = [{
    id: 1,
    name: 'João Silva',
    phone: '+55 11 97777-7777',
    email: 'joao.silva@email.com',
    lists: ['Deputados', 'Coordenadores'],
    lastMessage: 'Hoje, 11:30',
    totalMessages: 45,
    createdAt: '15/01/2023',
    status: 'Ativo',
    notes: 'Contato preferencial para comunicações urgentes'
  }, {
    id: 2,
    name: 'Maria Oliveira',
    phone: '+55 11 96666-6666',
    email: 'maria.oliveira@email.com',
    lists: ['Deputados'],
    lastMessage: 'Ontem, 15:45',
    totalMessages: 32,
    createdAt: '20/02/2023',
    status: 'Ativo'
  }, {
    id: 3,
    name: 'Carlos Santos',
    phone: '+55 11 95555-5555',
    email: 'carlos.santos@email.com',
    lists: ['Deputados', 'Diretório Municipal'],
    lastMessage: '22/05/2023, 14:20',
    totalMessages: 28,
    createdAt: '10/03/2023',
    status: 'Ativo'
  }, {
    id: 4,
    name: 'Ana Souza',
    phone: '+55 11 94444-4444',
    lists: ['Deputados'],
    lastMessage: '20/05/2023, 09:15',
    totalMessages: 15,
    createdAt: '05/04/2023',
    status: 'Inativo'
  }, {
    id: 5,
    name: 'Roberto Ferreira',
    phone: '+55 11 93333-3333',
    email: 'roberto.ferreira@email.com',
    lists: ['Deputados', 'Suplentes'],
    lastMessage: '19/05/2023, 16:40',
    totalMessages: 52,
    createdAt: '12/01/2023',
    status: 'Ativo'
  }];
  const handleContactClick = (contact: any) => {
    setSelectedContact(contact);
    setModalOpened(true);
  };
  const activeContacts = contacts.filter(c => c.status === 'Ativo').length;
  const totalMessages = contacts.reduce((sum, c) => sum + c.totalMessages, 0);
  return <div className="space-y-6" data-id="element-392">
      <Button leftSection={<ArrowLeft size={18} data-id="element-394" />} onClick={() => navigate('/lists')} radius="lg" styles={{
      root: {
        backgroundColor: 'transparent',
        border: '1px solid #9ca3af',
        color: '#4b5563',
        height: '40px',
        '&:hover': {
          backgroundColor: '#f3f4f6'
        }
      }
    }} data-id="element-393">
        Voltar para Listas
      </Button>
      <div className="flex justify-between items-center" data-id="element-395">
        <div data-id="element-396">
          <Title order={2} className="text-primary" data-id="element-397">
            {listName}
          </Title>
          <Text c="dimmed" data-id="element-398">{listDescription}</Text>
        </div>
        <Group data-id="element-399">
          <Button leftSection={<Download size={18} data-id="element-401" />} radius="lg" styles={{
          root: {
            backgroundColor: 'transparent',
            border: '1px solid #00A86B',
            color: '#00A86B',
            height: '48px',
            '&:hover': {
              backgroundColor: '#E8F5E9'
            }
          }
        }} data-id="element-400">
            Exportar
          </Button>
          <Button leftSection={<Upload size={18} data-id="element-403" />} radius="lg" styles={{
          root: {
            backgroundColor: 'transparent',
            border: '1px solid #0047AB',
            color: '#0047AB',
            height: '48px',
            '&:hover': {
              backgroundColor: '#E3F2FD'
            }
          }
        }} data-id="element-402">
            Importar
          </Button>
          <Button leftSection={<Plus size={18} data-id="element-405" />} radius="lg" styles={{
          root: {
            backgroundColor: '#0047AB',
            height: '48px',
            '&:hover': {
              backgroundColor: '#003d91'
            }
          }
        }} data-id="element-404">
            Adicionar Contato
          </Button>
        </Group>
      </div>
      <SimpleGrid cols={{
      base: 1,
      sm: 2,
      lg: 4
    }} data-id="element-406">
        <Paper radius="lg" p="md" withBorder data-id="element-407">
          <Group justify="space-between" mb="xs" data-id="element-408">
            <Text size="sm" c="dimmed" data-id="element-409">
              Total de Contatos
            </Text>
            <Users size={20} style={{
            color: '#0047AB'
          }} data-id="element-410" />
          </Group>
          <Title order={2} data-id="element-411">{contacts.length}</Title>
          <Text size="xs" c="dimmed" mt="xs" data-id="element-412">
            Nesta lista
          </Text>
        </Paper>
        <Paper radius="lg" p="md" withBorder data-id="element-413">
          <Group justify="space-between" mb="xs" data-id="element-414">
            <Text size="sm" c="dimmed" data-id="element-415">
              Contatos Ativos
            </Text>
            <TrendingUp size={20} style={{
            color: '#00A86B'
          }} data-id="element-416" />
          </Group>
          <Title order={2} data-id="element-417">{activeContacts}</Title>
          <Text size="xs" c="green" mt="xs" data-id="element-418">
            {(activeContacts / contacts.length * 100).toFixed(0)}% do total
          </Text>
        </Paper>
        <Paper radius="lg" p="md" withBorder data-id="element-419">
          <Group justify="space-between" mb="xs" data-id="element-420">
            <Text size="sm" c="dimmed" data-id="element-421">
              Total de Mensagens
            </Text>
            <MessageCircle size={20} style={{
            color: '#9333EA'
          }} data-id="element-422" />
          </Group>
          <Title order={2} data-id="element-423">{totalMessages}</Title>
          <Text size="xs" c="dimmed" mt="xs" data-id="element-424">
            Enviadas para esta lista
          </Text>
        </Paper>
        <Paper radius="lg" p="md" withBorder data-id="element-425">
          <Group justify="space-between" mb="xs" data-id="element-426">
            <Text size="sm" c="dimmed" data-id="element-427">
              Média por Contato
            </Text>
            <MessageCircle size={20} style={{
            color: '#FFCC00'
          }} data-id="element-428" />
          </Group>
          <Title order={2} data-id="element-429">
            {(totalMessages / contacts.length).toFixed(0)}
          </Title>
          <Text size="xs" c="dimmed" mt="xs" data-id="element-430">
            Mensagens por contato
          </Text>
        </Paper>
      </SimpleGrid>
      <Paper radius="lg" p="md" withBorder data-id="element-431">
        <Group justify="space-between" mb="md" data-id="element-432">
          <Group data-id="element-433">
            <TextInput placeholder="Buscar contatos..." leftSection={<Search size={18} data-id="element-435" />} className="w-full max-w-md" data-id="element-434" />
            <Select placeholder="Status" data={[{
            value: 'all',
            label: 'Todos'
          }, {
            value: 'active',
            label: 'Ativos'
          }, {
            value: 'inactive',
            label: 'Inativos'
          }]} leftSection={<Filter size={18} data-id="element-437" />} clearable data-id="element-436" />
            <Select placeholder="Outras listas" data={[{
            value: 'all',
            label: 'Todas'
          }, {
            value: 'coordenadores',
            label: 'Coordenadores'
          }, {
            value: 'suplentes',
            label: 'Suplentes'
          }, {
            value: 'diretorio',
            label: 'Diretório Municipal'
          }]} clearable data-id="element-438" />
            <Select placeholder="Ordenar por" data={[{
            value: 'name',
            label: 'Nome'
          }, {
            value: 'messages',
            label: 'Nº de Mensagens'
          }, {
            value: 'date',
            label: 'Data de Cadastro'
          }]} defaultValue="name" data-id="element-439" />
          </Group>
        </Group>
        <Table highlightOnHover data-id="element-440">
          <Table.Thead data-id="element-441">
            <Table.Tr data-id="element-442">
              <Table.Th data-id="element-443">Nome</Table.Th>
              <Table.Th data-id="element-444">Telefone</Table.Th>
              <Table.Th data-id="element-445">Status</Table.Th>
              <Table.Th data-id="element-446">Outras Listas</Table.Th>
              <Table.Th data-id="element-447">Mensagens</Table.Th>
              <Table.Th data-id="element-448">Última Mensagem</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody data-id="element-449">
            {contacts.map(contact => <Table.Tr key={contact.id} className="cursor-pointer hover:bg-gray-50" onClick={() => handleContactClick(contact)} data-id="element-450">
                <Table.Td data-id="element-451">
                  <Group data-id="element-452">
                    <Avatar radius="xl" style={{
                  backgroundColor: '#E3F2FD',
                  color: '#003d91'
                }} data-id="element-453">
                      <Users size={18} data-id="element-454" />
                    </Avatar>
                    <Text fw={500} data-id="element-455">{contact.name}</Text>
                  </Group>
                </Table.Td>
                <Table.Td data-id="element-456">{contact.phone}</Table.Td>
                <Table.Td data-id="element-457">
                  <Badge color={contact.status === 'Ativo' ? 'green' : 'gray'} variant="light" data-id="element-458">
                    {contact.status}
                  </Badge>
                </Table.Td>
                <Table.Td data-id="element-459">
                  <Group gap="xs" data-id="element-460">
                    {contact.lists.filter(list => list !== listName).slice(0, 2).map((list, index) => <Badge key={index} color="blue" variant="light" data-id="element-461">
                          {list}
                        </Badge>)}
                    {contact.lists.filter(list => list !== listName).length > 2 && <Badge color="gray" variant="light" data-id="element-462">
                        +
                        {contact.lists.filter(list => list !== listName).length - 2}
                      </Badge>}
                  </Group>
                </Table.Td>
                <Table.Td data-id="element-463">
                  <Text size="sm" data-id="element-464">{contact.totalMessages}</Text>
                </Table.Td>
                <Table.Td data-id="element-465">
                  <Text size="sm" c="dimmed" data-id="element-466">
                    {contact.lastMessage}
                  </Text>
                </Table.Td>
              </Table.Tr>)}
          </Table.Tbody>
        </Table>
      </Paper>
      {selectedContact && <ContactDetailsModal opened={modalOpened} onClose={() => setModalOpened(false)} contact={selectedContact} data-id="element-467" />}
    </div>;
}